"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaturitiesNextMaturitiesToJSON = exports.MaturitiesNextMaturitiesFromJSONTyped = exports.MaturitiesNextMaturitiesFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function MaturitiesNextMaturitiesFromJSON(json) {
    return MaturitiesNextMaturitiesFromJSONTyped(json, false);
}
exports.MaturitiesNextMaturitiesFromJSON = MaturitiesNextMaturitiesFromJSON;
function MaturitiesNextMaturitiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': !(0, runtime_1.exists)(json, 'date') ? undefined : json['date'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : (0, _1.AmountFromJSON)(json['amount']),
        'percentageOfMaxAmount': !(0, runtime_1.exists)(json, 'percentageOfMaxAmount') ? undefined : json['percentageOfMaxAmount'],
    };
}
exports.MaturitiesNextMaturitiesFromJSONTyped = MaturitiesNextMaturitiesFromJSONTyped;
function MaturitiesNextMaturitiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'amount': (0, _1.AmountToJSON)(value.amount),
        'percentageOfMaxAmount': value.percentageOfMaxAmount,
    };
}
exports.MaturitiesNextMaturitiesToJSON = MaturitiesNextMaturitiesToJSON;
//# sourceMappingURL=MaturitiesNextMaturities.js.map